import { useEffect, useState } from "react";
import PageHero from "@/components/PageHero";
import CTABanner from "@/components/CTABanner";
import { Reveal } from "@/components/Reveal";
import { FACILITY_ICONS } from "@/lib/icons";
import { api } from "@/lib/api";

export default function Facilities() {
  const [facilities, setFacilities] = useState([]);

  useEffect(() => {
    document.title = "Facilities | Sagar Darshan Guest House, Somnath Gujarat";
    api.facilities().then(setFacilities).catch(() => {});
  }, []);

  return (
    <div data-testid="facilities-page">
      <PageHero overline="Facilities" title="Everything You Need for a Comfortable Stay"
        image="https://customer-assets-gfyr7b9c.emergentagent.net/job_somnath-coastal-stay/artifacts/da12r0sm_IMG_0891.jpeg" />
      <section className="mx-auto max-w-7xl px-5 py-24 lg:px-10 lg:py-32">
        <div className="grid gap-px border border-navy/10 bg-navy/10 sm:grid-cols-2 lg:grid-cols-3">
          {facilities.map((f, i) => {
            const Icon = FACILITY_ICONS[f.icon] || FACILITY_ICONS.sparkles;
            return (
              <Reveal key={f.title} delay={(i % 3) * 0.08}>
                <div data-testid={`facility-detail-${f.icon}`} className="group flex h-full flex-col gap-4 bg-white p-9 transition-colors duration-500 hover:bg-sand">
                  <Icon size={30} strokeWidth={1.1} className="text-gold-dark transition-transform duration-500 group-hover:-translate-y-1" />
                  <p className="font-display text-xl text-navy">{f.title}</p>
                  <p className="text-sm leading-relaxed text-navy/60">{f.desc}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </section>
      <CTABanner />
    </div>
  );
}
